import { render } from "./AnnotationPanel.vue?vue&type=template&id=125384a8&scoped=true"
import script from "./AnnotationPanel.vue?vue&type=script&lang=js"
export * from "./AnnotationPanel.vue?vue&type=script&lang=js"

import "./AnnotationPanel.vue?vue&type=style&index=0&id=125384a8&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-125384a8"]])

export default __exports__